export default __webpack_public_path__ + "images/d22d395ec9107f84bc83fed6c9894757-4_mobile_659x494.webp";